$(document).ready(function() {
	$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
});

jQuery(".footer-block--menu .footer-block__heading").click(function(){
  if($(window).width() <= '749'){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".footer-block--menu .footer-block__heading").removeClass("show");
          jQuery(".footer-block--menu .footer-block__heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
    }
});

// $('.home_banner_slider').slick({
//   infinite: true,
//   arrows:false,
//   dots:true,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   slidesToShow: 1,
//   slidesToScroll: 1
// });
// $('.home_banner_slider').slick({
//   infinite: true,         
//   arrows: false,          
//   dots: true,             
//   autoplay: true,         
//   autoplaySpeed: 3000,    
//   speed: 800,             
//   slidesToShow: 1,        
//   slidesToScroll: 1,      
//   pauseOnHover: true      
// });

  document.addEventListener("DOMContentLoaded", function () {
    var slider = $('.home_banner_slider');
    var sliderSpeed = slider.data('speed'); 
    var autoPlay = slider.data('autoplay');

    slider.slick({
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: autoPlay,
      autoplaySpeed: 2500 , 
      speed: sliderSpeed,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  });

